import React from 'react';

const Impressum = () => {

    return(
        <>
            <div className="heading" style={{padding:"60px 0", display:"flex", flexDirection:"column", justifyContent:"center", background:"#940000"}}></div>
            <div style={{marginLeft: "15px"}}>
                <h1 style={{marginTop: "15px"}}>Impressum</h1>

                <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
                <p>Strings and more e.V.<br />
                Musterstra&szlig;e 111<br />
                Geb&auml;ude 44<br />
                90210 Musterstadt</p>

                <p><strong>Vertreten durch:</strong><br />
                Dr. Harry Mustermann<br />
                Luise Beispiel</p>

                <h2>Kontakt</h2>
                <p>Telefon: +49 (0) 123 44 55 66<br />
                Telefax: +49 (0) 123 44 55 99<br />
                E-Mail: mustermann@musterfirma.de</p>

                <h2>Umsatzsteuer-ID</h2>
                <p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
                DE999999999</p>

                <h2>Redaktionell verantwortlich</h2>
                <p>Beate Beispielhaft<br />
                Musterstra&szlig;e 110<br />
                90210 Musterstadt</p>

                <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

                <p style={{marginBottom: "15px"}}>Quelle: <a href="https://www.e-recht24.de/impressum-generator.html">https://www.e-recht24.de/impressum-generator.html</a></p>
            </div>
    </>    
    );
};

export default Impressum;